<template>
  <div class="font_Montserrat font_size_1000rem">
    <b-nav tabs justified>
      <b-nav-item to="/welcome" :disabled="isLoginPage || isRegisterPage">
        <span class="d-flex align-items-center">
          <img :src="getImgUrl('welcome.svg')" class="mr-2" />
          <span class="d-none d-md-block">Welcome</span>
        </span>
      </b-nav-item>
      <b-nav-item to="/welcome/dashboard" :disabled="isLoginPage || isRegisterPage">
        <span class="d-flex align-items-center">
          <img :src="getImgUrl('dashboard-icon.svg')" class="mr-2" />
          <span class="d-none d-md-block">Dashboard</span>
        </span>
      </b-nav-item>
      <b-nav-item to="/welcome/share" :disabled="isLoginPage || isRegisterPage">
        <span class="d-flex align-items-center">
          <img :src="getImgUrl('share-icon.svg')" class="mr-2" />
          <span class="d-none d-md-block">Share</span>
        </span>
      </b-nav-item>
      <b-nav-item to="/welcome/inform" :disabled="isLoginPage || isRegisterPage">
        <span class="d-flex align-items-center">
          <img :src="getImgUrl('inform-icon.svg')" class="mr-2" />
          <span class="d-none d-md-block">Inform</span>
        </span>
      </b-nav-item>
      <b-nav-item to="/welcome/connect" :disabled="isLoginPage || isRegisterPage">
        <span class="d-flex align-items-center">
          <img :src="getImgUrl('connect-icon.svg')" class="mr-2" />
          <span class="d-none d-md-block">Connect</span>
        </span>
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
import ImageUrlMixin from '@/mixins/ImageUrlMixin';

export default {
  name: 'PrePaywallMenuItems',
  mixins: [ImageUrlMixin],
  computed: {
      isLoginPage: function () {
         return this.$route.path === '/login' || this.$route.path === '/registration';
      },
      isRegisterPage: function () {
        return this.$route.path.includes('/register');
      }
  }
};
</script>

<style scoped lang="scss">
@import '../../../../sass/v2';
.nav-tabs {
  .nav-item {
    .nav-link {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 76px;
      background-color: $phairify_v2_color_alice_blue;
      text-transform: uppercase;
      letter-spacing: 1.4px;
      color: $phairify_v2_color_black_knight;
      border: 0;
      border-radius: 0;
      border-right: 1px solid rgba(#031724, 0.2);
      &:hover {
        border-right: 1px solid rgba(#031724, 0.2);
      }
      &.router-link-exact-active {
        background: #ffffff 0% 0% no-repeat padding-box;
        border-right: 1px solid rgba(#031724, 0.2);
      }
    }
    &:last-child {
      .nav-link {
        border-right: 0;
      }
    }
  }
}
</style>
